import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isDrawerOpen: false,
};

const drawerSlice = createSlice({
    name: 'drawer',
    initialState,
    reducers: {
        toggleDrawer: (state) => {
            state.isDrawerOpen = !state.isDrawerOpen;
        },
        setDrawerOpen: (state, action) => {
            state.isDrawerOpen = action.payload;
        },
    },
});

export const { toggleDrawer, setDrawerOpen } = drawerSlice.actions;
export default drawerSlice.reducer;